import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { showInfoMessage } from 'ducks/layout';
import { useCore } from 'contexts/core';
import { ErrorMessage, getToastMessage } from '../utils/errorMessages';
import { ErrorMessages } from '@inter-ikea-storageone/range';
import { useTranslations } from 'hooks/useTranslations';
import { useIntl } from 'react-intl';
import { useServiceSettings } from 'contexts/serviceSettings';

const ErrorMessageToast = () => {
  const dispatch = useDispatch();
  const coreApi = useCore();
  const { useMetric } = useTranslations();
  const { translations } = useServiceSettings();
  const { formatMessage } = useIntl();

  const [message, setMessage] = useState<ErrorMessage | null>(null);
  const [messagesToIgnore, setMessagesToIgnore] = useState<ErrorMessages[]>([]);

  useEffect(() => {
    const onPlacementAttempt = (m: ErrorMessages) => {
      const errorMessage = getToastMessage(
        formatMessage,
        coreApi,
        dispatch,
        useMetric,
        m,
        translations
      );
      !messagesToIgnore.includes(m) && setMessage(errorMessage);
      if (errorMessage?.showOnce) {
        setMessagesToIgnore([...messagesToIgnore, m]);
      }
    };
    return coreApi.subscribe('placementAttempt', onPlacementAttempt);
  }, [coreApi, dispatch, messagesToIgnore, useMetric, formatMessage, translations]);

  useEffect(() => {
    const reset = () => {
      setMessagesToIgnore([]);
    };
    return coreApi.subscribe('reset', reset);
  }, [coreApi]);

  useEffect(() => {
    if (message) {
      dispatch(
        showInfoMessage({
          message: message.body,
          params: message.params,
          action: message.action
        })
      );
    }
  }, [dispatch, message]);

  return null;
};

export default ErrorMessageToast;
